<div class="bk-page sb">
  <header class="bk-page__head sb__head">
    <div class="bk-page__intro">
      <app-back-button class="sb__back" label="Segments" (back)="backToSegments()" />
      <p class="bk-eyebrow">Segment</p>
      <h1 class="bk-page__title">New segment</h1>
      <p class="bk-page__sub">{{ description }}</p>
    </div>
  </header>

  <alternative-stepper class="sb__steps" [steps]="steps" [noContent]="true" />

  <div class="sb__body">
    @switch (searchQuery) {
      @case ('review') {
        <segment-review />
      }
      @case ('rule') {
        <segment-rule />
      }
      @default {
        <segment-information />
      }
    }
  </div>
</div>
